import { inquiryType, gtmEventType, contactType, phoneType } from '@Components/Utilities/SandhillsConstants';
import { gtmPushEvent, sandhillsRequest, truncateString } from '@Components/Utilities/SandhillsUtility';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import TranslationText from '@Components/Utilities/TranslationText';
import ListingGridImage from '@Components/Listings/ListingGridImage';
import CollapsibleContacts from '@Components/Contact/CollapsibleContacts';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useRef, useState, useEffect } from 'react';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const ListingDisplayLocation = loadable(() => import('@Components/Shared/Listings/ListingDisplayLocation'));
const TextMessage = loadable(() => import('@Components/Contact/TextMessage'));

const PartsListListing = (props) => {
    const windowSize = useWindowSize();
    const ref = useRef([]);
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const routes = useRecoilValue(atoms.routes);
    const [showExpandedSpecs, setShowExpandedSpecs] = useState(false);
    const descriptionDefaultCharCount = 20;
    const descriptionExpandedCharCount = 150;
    const showWhatsApp = props.WhatsAppLink && !currentSite?.Site?.IsDotCom;
    const numContactButtons = showWhatsApp ? 3 : 2; // Unlike regular web listings, parts listings always have both an email and phone number
    const [showExpandedDescription, setShowExpandedDescription] = useState(false);
    const [descriptionCharCount, setDescriptionCharCount] = useState(descriptionDefaultCharCount);
    const openEmailModal = (inquiry) => {
        const mediaURL = props?.MediaModel?.Media?.length > 0 ? new URL(props.MediaModel.Media[0]?.MediaUrl) : '';

        props.openEmailModal(inquiry, contactType.Retail, {
            ModalTitle: (props.Manufacturer || '') + ' Part #: ' + props.PartNumber,
            Subject: (props.Manufacturer || '') + ' Part #: ' + props.PartNumber,
            ListingID: props.PartID,
            ListingSourceDomainUrl: props.ListingSourceDomainUrl,
            PartNumber: props.PartNumber,
            Price: props.RetailPrice || '',
            Manufacturer: props.Manufacturer,
            DealerCRMID: props.DealerCRMID,
            DealerGroupID: props.DealerGroupID,
            BranchName: props.DealerName || '',
            DealerLocation: props?.DealerLocation || props?.ListingLocation?.ShortLocation || props?.ListingLocation?.FormattedLocation,
            DealerPhone: props?.FormattedRetailPhoneNumber || '',
            DealerContact: props.DealerContact || '',
            ListingURL: props.SAMURL ?? props.DetailPageURL,
            MediaID: mediaURL?.searchParams?.get('id'),
            PartsSource: props.partsSource,
            IsParts: true,
            ListingCondition: props.Condition,
            Ref: ref.current[inquiry]
        });
    }

    const saveIterableAction = (actionName) => {
        sandhillsRequest({
            url: routes.SaveAction,
            method: 'post',
            data: {
                'email': '',
                'actionName': actionName,
                'manufacturers': [props.Manufacturer],
                'categoryIDs': [props.CategoryID],
                'partIDs': [props.PartID],
                'conditions': [props.Condition]
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        });
    };
    // RMBUYNOW
    const handleBuyNowClick = () => {
        saveIterableAction('buyNow');
        gtmPushEvent(gtmEventType.buyNowClick);
    }

    const handleTelClick = () => {
        saveIterableAction('telClick');
        gtmPushEvent(gtmEventType.call);
    }

    useEffect(() => {
        handleSpecsOrDescriptionChange(props.showAllSpecs, props.expandDescription);
    }, [props.showAllSpecs, props.expandDescription]);

    const handleSpecsOrDescriptionChange = (showSpecs, showDescription) => {
        setShowExpandedSpecs(showSpecs);

        if (showDescription) {
            setDescriptionCharCount(descriptionExpandedCharCount);
        } else {
            setDescriptionCharCount(descriptionDefaultCharCount);
        }
        setShowExpandedDescription(showDescription);
    }

    const handleDescriptionToggle = () => {
        if (!showExpandedDescription) {
            setDescriptionCharCount(descriptionExpandedCharCount);
        };
        setShowExpandedDescription(!showExpandedDescription);
    }

    return (
        <div className='parts-listing-container'>
            <div className='parts-listing-row'>
                {props.InventoryManagementURL && <a className='part-name-value' href={props.InventoryManagementURL} target='_blank' aria-label={"View in Inventory Management (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                    <strong>View in Inventory Management</strong></a>}
                <a className='part-name-value-large' href={props.DetailPageURL}><strong>{props.Title}</strong></a>
                {props.SubTitle && <span className='part-make-value'>
                    <strong>{props.SubTitle}</strong>
                </span>
                }
                {props.CategoryName && <span className='part-category-name'>
                    <strong>{props.CategoryName}</strong>
                </span>
                }
            </div>
            {!props.NoImageRow &&
                <div className={'image-container' + (props.MediaModel.Media.length > 0 ? '' : ' no-media')}>
                    {
                        props.MediaModel.Media.length > 0 ?
                            <ListingGridImage DetailUrl={props.DetailPageURL} ImageUrl={props.MediaModel.Media.map(media => media.MediaUrl)} IsParts={true} AltText={props.PartNumber} AriaLabelTitle={props.AriaLabelTitle} />
                            :
                            <a href={props.DetailPageURL} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.viewdetailsfor') + " " + props.AriaLabelTitle}>
                                <div className='media-control-no-photo' />
                            </a>
                    }
                </div>
            }
            <div className='parts-listing-row'>
                <span className='part-list-price'>
                    <strong>
                        {props.FormattedDiscountPrice || props.Price ?
                            (props.FormattedDiscountPrice ?
                                <span>
                                    <span className='part-list-msrp'>{props.Price}</span>
                                    {props.DiscountSavePercentage && <span className='list-msrp-save-percentage'>{props.DiscountSavePercentage}</span>}
                                    <div className='discountedPrice'><span>{props.FormattedDiscountPrice}</span></div>
                                </span>
                                :
                                (props.ShowMSRPField && props.MSRP ?
                                    <span>
                                        <span className='part-list-msrp'>{props.MSRP}</span>
                                        {props.MSRPSavePercentage && <span className='list-msrp-save-percentage'>{props.MSRPSavePercentage}</span>}
                                        <div><span>{props.Price}</span></div>
                                    </span>
                                    :
                                    <span>{props.Price}</span>
                                )
                            )
                            :
                            <span>{translator.translate('sandhills.callforprice')}</span>
                        }
                    </strong>
                </span>
                {/*RMBUYNOW*/}{currentSite?.Site?.IsHostedSite && props.BuyNowURL ?
                    <a className='buy-btn des-buy-now' href={props.BuyNowURL} onClick={handleBuyNowClick} target={(props.BuyNowNewTab || currentSite.IsMobileAppContext) ? '_blank' : '_self'} aria-label={(props.BuyNowNewTab || currentSite.IsMobileAppContext) ? translator.translate('sandhills.buynow') + " - " + props.AriaLabelTitle + " (" + translator.translate('sandhills.opensinanewtab') + ")" : translator.translate('sandhills.buynow') + " - " + props.AriaLabelTitle}>
                        <i className='fas fa-shopping-cart' />
                        <TranslationText tKey='sandhills.buynow' />
                    </a>
                    :
                    <a className='view-listing-details-link des-view-listingDetails' href={props.DetailPageURL} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.viewdetailsfor') + ' ' + props.AriaLabelTitle}>
                        <i className='fas fa-search-plus' aria-hidden='true' />
                        <strong><TranslationText tKey='sandhills.viewdetails' /></strong>
                    </a>
                }
                {props.Quantity &&
                    <div key={'quantity'} className='part-spec'>
                        <span className='spec-label'><TranslationText tKey='sandhills.crm.dscrm.available' />:&nbsp;</span>
                        <span className='spec-value'>{props.Quantity}</span>
                    </div>
                }
                {props.Condition &&
                    <div key={'condition'} className='part-spec'>
                        <span className='spec-label'><TranslationText tKey='sandhills.condition' />:&nbsp;</span>
                        <span className='spec-value'>{props.Condition}</span>
                    </div>
                }
                {props.Description && props.Description.trim() !== '' &&
                    <div key={'desc'}>
                        <p className='part-description'>
                            <strong>{translator.translate('sandhills.description')}:&nbsp;</strong>
                            <span className='spec-value'>{truncateString(props.Description, descriptionCharCount)}&nbsp;</span>
                            {props.Description.length > descriptionDefaultCharCount &&
                                <>
                                    {showExpandedDescription ?
                                        <>
                                        <a className='see-more' href={props.DetailPageURL} target={props.openDetailPageInNewTab ? "_blank" : "_self"} aria-label={props.openDetailPageInNewTab ? translator.translate('sandhills.seemoredetails') + " - " + props.AriaLabelTitle + " (" + translator.translate('sandhills.opensinanewtab') + ")" : translator.translate('sandhills.seemoredetails') + " - " + props.AriaLabelTitle}>
                                            <TranslationText tKey='sandhills.seemoredetails' />
                                        </a>
                                        </>
                                        :
                                    <span className='read-more' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); handleDescriptionToggle(); } }} onClick={handleDescriptionToggle}><strong>{translator.translate('sandhills.readmore')}</strong></span>
                                    }
                                </>
                            }
                        </p>
                    </div>
                }
                {showExpandedSpecs &&
                    <div key={'more-specs'} className="collapsible-specs">
                        {props.CreatedOn &&
                            <div key={'created'} className='part-spec'>
                                <span className='spec-label'><TranslationText tKey='sandhills.createdon' />:&nbsp;</span>
                                <span className='spec-value'>{props.CreatedOn}</span>
                            </div>
                        }
                        {props.Updated && props.CreatedOn != props.Updated &&
                            <div key={'updated'} className='part-spec'>
                                <span className='spec-label'><TranslationText tKey='sandhills.updated' />:&nbsp;</span>
                                <span className='spec-value'>{props.Updated}</span>
                            </div>
                        }
                    </div>}
                <div className='specs-button' aria-label={showExpandedSpecs ? translator.translate('sandhills.hostedstore.showmore') : translator.translate('sandhills.showless')} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); setShowExpandedSpecs(!showExpandedSpecs); } }} onClick={() => setShowExpandedSpecs(!showExpandedSpecs)}><span className="toggle-label">{showExpandedSpecs ? translator.translate('sandhills.showless') : translator.translate('sandhills.hostedstore.showmore')}</span><i className={showExpandedSpecs ? 'fas fa-angle-up' : 'fas fa-angle-down'} /></div>
                {props.ListingLocation && <ListingDisplayLocation {...props.ListingLocation} OneLine UseShortDisplay />}
            </div>
            <div className='parts-listing-contact'>
                <div className='contact-container'>
                    <div className={`shared count-${numContactButtons}`}>
                        {props.ShowCheckAvailability ?
                            <div className={'email'} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); openEmailModal(inquiryType.CheckAvailability); } }} onClick={() => openEmailModal(inquiryType.CheckAvailability)}>
                                <i className='fas fa-check' /> <TranslationText tKey='sandhills.checkavailability' />
                            </div>
                            :
                            <div className={'email'} ref={ref} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); openEmailModal(inquiryType.Email); } }} onClick={() => openEmailModal(inquiryType.Email)}>
                                <i className='fas fa-envelope' /> {showWhatsApp ? '' : (props.CustomEmailSellerTextForRental ? props.CustomEmailSellerTextForRental : props.CustomEmailSellerTextForRetail ? props.CustomEmailSellerTextForRetail : (props.IsForRentOnly || props.IsRY) ? <TranslationText tKey='sandhills.email' /> : <TranslationText tKey='sandhills.emailseller' />)}
                            </div>
                        }
                        {showWhatsApp &&
                            <div className='dealer-data'>
                                <i className='fa-brands fa-whatsapp' />&nbsp;
                                <a href={props.WhatsAppLink} data-phonetype={phoneType.WhatsApp} className=' whatsapp-link' target='_blank' aria-label={translator.translate('sandhills.whatsapp') + " (" + translator.translate('sandhills.opensinanewtab') + ")"} onClick={(e) => { phoneClickToTrack(e, props.WhatsAppUnformattedPhoneNumber, phoneType.WhatsApp); gtmPushEvent(gtmEventType.whatsApp); }}>
                                    <strong>{translator.translate('sandhills.whatsapp')}</strong>
                                </a>
                            </div>
                        }
                        <div className='dealer-data'>
                            <i className='fas fa-phone-alt' />&nbsp;
                            <a href={'tel:' + props.UnformattedRetailPhoneNumber} onClick={handleTelClick}>{props.FormattedRetailPhoneNumber}</a>
                        </div>
                    </div>
                    <div className='seller'>
                        <TranslationText tKey='sandhills.seller' />:{' '}
                        {props.DealerWebsiteURL ?
                            <a href={props.DealerWebsiteURL} target='_blank' aria-label={props.DealerName+ " (" + translator.translate('sandhills.opensinanewtab') + ")"}>{props.DealerName}</a>
                            :
                            props.DealerName
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PartsListListing;